import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { CookiesService } from './cookies.service';
import { EventsService } from './events.service';
import { AuthService } from '@auth0/auth0-angular';

import { FormGroup } from '@angular/forms';
import { CnpjService } from './cnpj.service';
import { catchError, map, of, Subject, take, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private destroy$ = new Subject<void>();

  formSearch!: FormGroup;
  searchedCnpj: string = '';
  picture: string | null | undefined = '';

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private auth0: AuthService,
    private cookies: CookiesService,
    private eventService: EventsService,
    private cnpjService: CnpjService
  ) { }

  public logout(): void {
    this.cookies.removeItem('TOKEN', '/');
    this.cookies.removeItem('TOKEN');
    this.cookies.clearCookies();
    localStorage.removeItem('CNPJ');
    localStorage.removeItem('CNPJ_NAME');
    localStorage.removeItem('savedHref');
    localStorage.removeItem('savedLocation');
    localStorage.removeItem('utm_params');
    this.eventService.rudderAnalytics?.reset();

    this.auth0.logout({
      logoutParams: {
        returnTo: this.document.location.origin
      }
    });
  }

  public loadCNPJFromStorage(): void {
    let cnpj = this.cnpjService.getSelectedCnpj();
    if (cnpj) {
      this.searchedCnpj = cnpj;
      this.cnpjService.setSelectedCnpj(this.searchedCnpj);
      // this.showDiv = true;
      // this.filtered = true;
    }
  }


  public toggleCnpjSelector(): void {
    this.cnpjService.showCnpjPopup(true);
  }

  public fetchUserPicture(): void {
    this.auth0.user$.pipe(
      take(1),
      map(response => response?.picture),
      catchError(error => {
        console.error('Erro ao obter a imagem do usuário:', error);
        return of(null);
      })
    ).subscribe(picture => {
      this.picture = picture;
    });
  }

  public getCnpj() {
    this.cnpjService.selectedCnpj$
      .pipe(takeUntil(this.destroy$))
      .subscribe((cnpj) => {
        this.searchedCnpj = cnpj;
      });
  }

}
